import { motion } from "framer-motion";

export const Anilhas = () => {
    const cards = [
        { img: "/img/calopsita.png", nome: "Calopsita", info: "Nymphicus hollandicus", tamanho: "5.5 mm" },
        { img: "/img/redOk.png", nome: "Red Rumped", info: "Psephotus haematonotus", tamanho: "4.5 mm" },
        { img: "/img/ring.png", nome: "Ring Neck", info: "Psittacula kramer", tamanho: "7.5 mm" },
        { img: "/img/rodelaOk.png", nome: "Rosela", info: "Psittacula kramer", tamanho: "5.5 mm" },
        { img: "/img/araraCaninde.png", nome: "Arara-Canindé", info: "Ara ararauna", tamanho: "13.5 mm" },
        { img: "/img/araraVerdadeiro.png", nome: "Papagaio Verdadeiro", info: "Amazona aestiva", tamanho: "10.0 mm" },
    ];

    const container = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.15,
            },
        },
    };

    const item = {
        hidden: { opacity: 0, y: 20 },
        show: { opacity: 1, y: 0 },
    };

    return (
        <section
            id="inicio"
            className="relative px-6 py-16 md:py-28 overflow-hidden z-10"
        >
            <div className="container mx-auto flex flex-col md:flex-row items-center justify-between relative z-10">
                <motion.div
                    className="md:w-1/2 text-left"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 1.2 }}
                >
                    <h1 className="text-3xl md:text-5xl font-bold text-gray-800">
                        Anilhas personalizadas
                    </h1>
                    <h1 className="text-3xl md:text-5xl text-gray-800 mt-5 mb-2">
                        com gravação a laser
                    </h1>
                    <p className="text-2xl mt-10">
                        Precisão, durabilidade e confiança para criadores de aves, com atendimento rápido e dedicado
                    </p>
                    <button
                        type="button"
                        className="mt-6 bg-[#40A835] text-white px-6 py-4 rounded-lg hover:bg-[#40A835] transition"
                    >
                        Ver modelos de anilhas
                    </button>
                </motion.div>
            </div>

            <section className="px-4 sm:px-6 md:px-10 py-16 max-w-7xl mx-auto">
                <motion.div
                    className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-5"
                    variants={container}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, amount: 0.2 }}
                >
                    {cards.map((ave) => (
                        <motion.div
                            key={ave.nome}
                            variants={item}
                            transition={{ duration: 0.5, ease: "easeOut" }}
                            className="bg-white p-6 rounded-xl shadow-md w-full hover:shadow-lg transition-shadow duration-300"
                        >
                            <img
                                src={ave.img}
                                alt={ave.nome}
                                className="mx-auto h-36 object-contain"
                            />
                            <h3 className="mt-4 text-lg font-semibold text-center">{ave.nome}</h3>
                            <p className="text-sm text-gray-600 text-center">{ave.info}</p>
                            <p className="text-green-700 font-semibold mt-1 text-center">{ave.tamanho}</p>
                        </motion.div>
                    ))}
                </motion.div>
            </section>
        </section>
    );
};
